import { Conf2AccountJwt } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const conf2AccountSignIn = createAction(
  "[Conf2] Account Sign In",
  props<{ jwt: Conf2AccountJwt }>()
);

export const conf2JwtQueryParamDelete = createAction(
  "[Conf2] Jwt Query Param Delete"
);
